import React from "react";
import RepeatableField from "@components/RepeatableField/RepeatablePrimitiveField";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema.ts";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const Children: React.FC = () => {
  const { formData } = useOutletContext<FormContext>();

  return (
    <FormProvider {...formData}>
      <RepeatableField
        name="children"
        sectionLabel={t("security-clearance.children")}
        label={t("security-clearance.child")}
        placeholder={t("security-clearance.child-name")}
        testId="children"
        onFieldChange={(key, arr) => {
          // this calls your zustand setter, e.g.:
          usePortSecurityFormStore.getState().setField(key as keyof PortSecurityFormData, arr);
        }}
        buttonLabel={t("buttons.addNew")}
        minItems={1}
        maxItems={8}
        maxChars={200}
      />
    </FormProvider>
  );
};

export default Children;
